import * as React from 'react'
import FadeInHOC from '@components/FadeInHOC'
import OurBeliefsSection from '@components/WeBelieveAccordion'
import styled from 'styled-components'
import { config } from 'react-awesome-styled-grid'
import { colors } from '@components/shared'
import BackgroundGradient from '@components/BackgroundGradient'

export default function OurBeliefs (): React.ReactNode {
  return (
    <Section>
      <BackgroundGradient
        quadrant={3}
        overlayColor='orange'
        parallax
      />
      <ContainerDiv className="container our-beliefs" id="our-beliefs">
        <FadeInHOC uniqueId="our-belief-section">
          <OurBeliefsSection />
        </FadeInHOC>
      </ContainerDiv>
    </Section>
  )
}

const Section = styled.section<any>`
  position: relative;
  overflow: hidden;
`
const ContainerDiv = styled.div<any>`
  overflow: hidden;
  padding-top: 70px;
  ${(props: any): any => config(props).media.md`
    padding-top: 100px;
  `}
  ${(props: any): any => config(props).media.lg`
    padding-top: 119px;
  `}

  &.our-beliefs {
    ${(props: any): any => config(props).media.md`
      padding-top: 82px;
    `}
    ${(props: any): any => config(props).media.lg`
      padding-top: 120px;
    `}
    ${(props: any): any => config(props).media.xl`
      padding: 120px 80px 0;
    `}
  }
  &#our-people {
    > div:first-child {
      padding-top: 58px;
    }
    padding-top: 0px;
    ${(props: any): any => config(props).media.md`
      padding-top: 80px;
      padding-bottom: 78px;
    `}
    ${(props: any): any => config(props).media.lg`
      padding-top: 220px;
      padding-bottom: 110px;
      .our-people-row-wrapper {
        > div:last-child {
          padding: 0 30px 0 16px;
        }
      }
    `}
    ${(props: any): any => config(props).media.xl`
      > div:first-child {
        max-width: 1212px;
        margin: 0 auto;
      }
      .our-people-row-wrapper {
        > div:last-child {
          padding: 0 30px 0 116px;
        }
      }
    `}
    background-color: ${colors.midnightBlue};
  }
  &.our-people {
    background: linear-gradient(rgb(38 18 47 / 0%) 40%,${colors.midnightBlue} 60%);
    ${(props: any): any => config(props).media.sm`
      background: linear-gradient(rgb(38 18 47 / 0%), ${colors.midnightBlue} 50%);
    `}
    ${(props: any): any => config(props).media.md`
      background: linear-gradient(rgb(38 18 47 / 0%) 50%, ${colors.midnightBlue});
    `}
  }
  &.our-process {
    background-color: ${colors.sand};
    padding-bottom: 60px;
    overflow: hidden;
    ${(props: any): any => config(props).media.md`
      padding-top: 80px;
      padding-bottom: 130px;
    `}
    ${(props: any): any => config(props).media.lg`
      padding-top: 120px;
      padding-bottom: 110px;
    `}
  }
`
